import { identityApiRef, useApi } from '@backstage/core-plugin-api';
import { useQuery } from '@tanstack/react-query';
import { governanceApiRef } from '../plugin';
import { getPoliciesNamesByIds } from '../utils/governanceUtils';

export const useGetNamesByPoliciesIds = ({ ids }: { ids: string[] }) => {
  const governanceApi = useApi(governanceApiRef);
  const identityApi = useApi(identityApiRef);

  return useQuery(['get-names-by-policies-ids', ids], async () =>
    getPoliciesNamesByIds(ids, governanceApi, identityApi),
  );
};
